import TAGGED from "../modules/tagged_content"
import { eventBlock } from '../plugins/event-case-block';

const [ w, d, l, content ] = [ window, document, location, 'case' ]

const init = () => {
  // 建築事業カテゴリの場合グローバルのcurrentを変更
  w.load['header'].then( () => {
    if( w.query_string('cat') == 8 ){
      $('header .p-gnav__list').currentMenu({mode: 0})
    }else{
      $('header .p-gnav__list').currentMenu({mode: 0, url: l.pathname })
    }
  })
}

const detail_init = async the_id => {

  // 全記事取得
  let articles = await $.getArticles({ content })
  let categories = await $.getCategories({ content })
  let the_article = articles.filter( a => (a.id == the_id) ).shift()
  the_article.category = categories.filter( c => c.id == the_article.category )[0]

  // 詳細ヘッダー
  let tags = keywords => {
    let html = ""
    if(!keywords || keywords.length == 0) return ''
    keywords.forEach( key => html += `<a href="/${content}/?mode=list&tag=${ encodeURI( key ) }">${key}</a>` )
    return `<div class="tags">${html}</div>`
  }
  let $head = $(`
    <div class="${content}-detail__head">
      ${the_article.category.name ? `<span class="cat">${the_article.category.name}</span>`: '' }
      <h3 class="title">${the_article.title}</h3>
      ${the_article.desc.length && the_article.category.id!='9' ? `<p class="desc">${the_article.desc}</p>`: '' }
      ${tags(the_article.keywords)}
    </div>
  `)
  $('.element_detail > .title, .detail_title').remove()
  $head.prependTo('.element_detail')
  
}

// 詳細イベント
const eventList = () => {
  const event_list = `
    <div class="case-event__wrap case-related">
      <h3 class="case-related__title">イベント</h3>
      <ul class="case-event__list">
        <li class="padding-xlarge text-center" style="width:100%">
          <i class="fa fa-circle-o-notch fa-spin text-grey fa-fw"></i>&nbsp;Loading...
        </li>
      </ul>
    </div>
  `
  $('#container').after(event_list);

  w.addEventListener('load', () => new eventBlock );
}


export default function CASE() {
  TAGGED({
    taglist_minimumTagAmount : 0, // タグの最低表示数
    taglist_hideUselessTags : 99999, // 最低使用回数
    taglist_titlename: {
      more: 'キーワードを見る',
      less: 'キーワードを非表示'
    },
  });
  $(() => {
    init()
    if( d.querySelectorAll('.element_detail').length ) detail_init( w.query_string('article') )
    if( d.querySelectorAll('.element_detail').length ) eventList()
  })
}